// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBeneficiaryAddressDto
 */
export interface IBeneficiaryAddressDto {
    /**
     * 
     * @type {number}
     * @memberof IBeneficiaryAddressDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryAddressDto
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryAddressDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryAddressDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryAddressDto
     */
    zipcode?: string;
}

/**
 * Check if a given object implements the IBeneficiaryAddressDto interface.
 */
export function instanceOfIBeneficiaryAddressDto(value: object): value is IBeneficiaryAddressDto {
    return true;
}

export function IBeneficiaryAddressDtoFromJSON(json: any): IBeneficiaryAddressDto {
    return IBeneficiaryAddressDtoFromJSONTyped(json, false);
}

export function IBeneficiaryAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBeneficiaryAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zipcode': json['zipcode'] == null ? undefined : json['zipcode'],
    };
}

export function IBeneficiaryAddressDtoToJSON(json: any): IBeneficiaryAddressDto {
    return IBeneficiaryAddressDtoToJSONTyped(json, false);
}

export function IBeneficiaryAddressDtoToJSONTyped(value?: IBeneficiaryAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'state': value['state'],
        'zipcode': value['zipcode'],
    };
}

